import {reqWithToken} from './requestHelper';


export async function removeFile(params){
    return await reqWithToken('api/pebooking/upload', {
        method: 'Delete',
        params
    });
}

export async function download(params){
    return (await reqWithToken('api/pebooking/upload', {
        params,
        responseType: 'blob'
    })).data;
}